<template>
  <a-tabs
    id="busyness-radio-button"
    size="small"
    :default-active-key="defaultValue"
    :tabBarStyle="{
      'borderBottom': 'none'
    }"
    :tabBarGutter=0
    @change="change"
  >
    <a-tab-pane
      v-for="item in options"
      :key="item.value"
      :tab="item.label"
    ></a-tab-pane>
  </a-tabs>
</template>

<script>
export default {
  name: 'RequestTypeRadio',
  props: {
    options: {
      type: Array
    },
    defaultValue: {
      type: String,
      default: 'all'
    }
  },
  methods: {
    change (v) {
      this.$emit('change', v)
    }
  }
}
</script>
<style lang="less">
#busyness-radio-button {
  .ant-tabs-nav-container {
    margin-left: -12px;
    height: 26px;
    .ant-tabs-nav-wrap {
      border-radius: 4px;
      .ant-tabs-tab {
        border-radius: 4px;
        font-size: 12px;
        color: #096dd9;
        padding: 0 14px;
        line-height: 26px;
        height: 26px;
        margin-left: 12px;
        border: 1px solid;
        background: #fff;
        border-color: #096dd9;
      }
      .ant-tabs-tab-active {
        background: #096dd9;
        color: #fff;
      }
      .ant-tabs-ink-bar {
        width: 0 !important;
      }
    }
  }
}
</style>
